import Analytics from 'aria-viewer/analytics/utils/analytics'
import idleTimer from 'aria-viewer/utils/idleTimer'
import { userIdled } from 'aria-viewer/tour/tourActions'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { trigger, events } from 'aria-viewer/legacy/tour/versions/v2/eventHandler'
import SocketProxy from 'aria-viewer/analytics/utils/socket/socketProxy'
import Socket from 'aria-viewer/analytics/utils/socket/socket'
import kinesisAnalytics from 'aria-viewer/analytics/utils/kinesisAnalytics'

const idleManager = {
    idle: false,
    timedOut: false,
    activeSinceLastReset: true,
}

new idleTimer({
    // function to fire after idle
    callback: () => {
        idleManager.idle = true
    },
    // function to fire when active after being idle
    activeCallback: () => {
        idleManager.idle = false
        idleManager.activeSinceLastReset = true
    },
    idleTime: 30000, // Amount of time in milliseconds before becoming idle (30 secs)
})

const initializeAnalytics = ({ inst_id, loc_id, stopid, socket, analyticsUrl, withReconnect = true }) => {
    // Reinitialize both legacy analytics and Kinesis analytics
    Analytics.init({ inst_id, loc_id, socket, analyticsUrl }).then(({ socket, analyticsUrl }) => {
        kinesisAnalytics.analyticsData.socket = socket || new Socket(analyticsUrl)

        withReconnect &&
            kinesisAnalytics.analyticsData.socket.reconnect &&
            kinesisAnalytics.analyticsData.socket.reconnect()
    })

    trigger(events.stopChanged, { stopid })
}

const idleAnalytics = {
    callback: ({ dispatch }) => {
        idleManager.timedOut = true
        Analytics.closeSocket()

        dispatch(userIdled())
    },

    activeCallback: ({ getState }) => {
        const { loc_id, owner_id: inst_id, stopid } = getTourData()(getState)

        const isIWC = getState().getIn(['device', 'isInIframe']) && getState().getIn(['device', 'useResponsiveUI'])
        const socket = isIWC ? SocketProxy : undefined

        idleManager.timedOut = false
        initializeAnalytics({
            inst_id,
            loc_id,
            stopid,
            socket,
            analyticsUrl: process.env.REACT_APP_ANALYTICS_WEBSOCKET_ENDPOINT,
        })
    },

    idleTime: 15 * 60 * 1000, // 15 minutes

    intervalCB: ({ getState }) => {
        if (idleManager.timedOut) return

        const { loc_id, owner_id: inst_id, stopid } = getTourData()(getState)

        if (idleManager.activeSinceLastReset) {
            const isIWC = getState().getIn(['device', 'isInIframe']) && getState().getIn(['device', 'useResponsiveUI'])
            const socket = isIWC ? SocketProxy : undefined

            initializeAnalytics({
                inst_id,
                loc_id,
                stopid,
                socket,
                analyticsUrl: process.env.REACT_APP_ANALYTICS_WEBSOCKET_ENDPOINT,
                withReconnect: false,
            })

            if (idleManager.idle) {
                idleManager.activeSinceLastReset = false
            }
        }
    },

    intervalTime: 15 * 60 * 1000, // 15 mintues
}

export default idleAnalytics
